import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class BridgeService {

  @Output() static carregado: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }



  menuCarregado() {
    BridgeService.carregado.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/bridge.service.ts